import api from './api';
import {UserLoginForm} from "../views/Login/Login";
import {ChangePasswordForm} from "../views/Login/ChangePassword";
import {IGetUser} from "../ts/interfaces/interface";
import {IGetProducts} from "../ts/interfaces/Product/interface";
import {IGetTeams} from "../ts/interfaces/Team/interface";
import {IGetCategories} from "../ts/interfaces/Category/interface";
import {IGetOrders, IPostUpdateOrderStatus, IPostUpdateStatus, IUpdateAddressRequest} from "../ts/interfaces/Order/interface";


// @ts-ignore
export const serialize = (obj) => {
    let str = [];
    for (let p in obj)
        if (obj.hasOwnProperty(p)) {
            str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
        }
    return str.join("&");
}

// @ts-ignore
export const serializeArray = (obj) => {
    let str = [];
    for (let p in obj) {
        if (obj.hasOwnProperty(p)) {
            if (Array.isArray(obj[p])) {
                for (let o in obj[p]) {
                    str.push(encodeURIComponent(p) + "[]=" + encodeURIComponent(obj[p][o]));
                }
            } else {
                str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
            }
        }
    }
    return str.join("&");
}

//Dashboard
export const getDataDashboard = () => Promise.resolve(api.get('/admin/dashboard'));

//User
export const login = (data: UserLoginForm) => Promise.resolve(api.post('/admin/auth/login', data));
export const rememberPassword = (data: {
    email: string,
    token: string | null
}) => Promise.resolve(api.post(`/admin/auth/remember-password`, data));
export const changePassword = (data: ChangePasswordForm) => Promise.resolve(api.put(`/admin/auth/password`, data));
export const getUser = (): Promise<IGetUser> => (api.get(`/admin/auth/me`));

//Product
export const getProduct = (id: number) => Promise.resolve(api.get('/admin/product/get/' + id));
export const storeProduct = (data: FormData) => Promise.resolve(api.post('/admin/product/store', data,
    {headers: {'Content-Type': 'multipart/form-data'}}));
export const deleteProduct = (id: number) => Promise.resolve(api.post('/admin/product/delete/' + id));
export const getProducts = (data: IGetProducts) => Promise.resolve(api.get('/admin/product/get-all', {params: data}));

//Team
export const getTeam = (id: number) => Promise.resolve(api.get('/admin/team/get/' + id));
export const storeTeam = (data: FormData) => Promise.resolve(api.post('/admin/team/store', data,
    {headers: {'Content-Type': 'multipart/form-data'}}));
export const deleteTeam = (id: number) => Promise.resolve(api.post('/admin/team/delete/' + id));
export const getTeams = (data: IGetTeams) => Promise.resolve(api.get('/admin/team/get-all', {params: data}));
export const filterTeams = () => Promise.resolve(api.get('/admin/team/filter'));

//Category
export const getCategory = (id: number) => Promise.resolve(api.get('/admin/category/get/' + id));
export const storeCategory = (data: FormData) => Promise.resolve(api.post('/admin/category/store', data,
    {headers: {'Content-Type': 'multipart/form-data'}}));
export const deleteCategory = (id: number) => Promise.resolve(api.post('/admin/category/delete/' + id));
export const getCategories = (data: IGetCategories) => Promise.resolve(api.get('/admin/category/get-all', {params: data}));
export const filterCategories = () => Promise.resolve(api.get('/admin/category/filter'));

//Orders
export const getOrder = (id: number) => Promise.resolve(api.get('/admin/order/get/' + id));
export const getOrders = (data: IGetOrders) => Promise.resolve(api.get('/admin/order/get-all', {params: data}));
export const filterOrders = () => Promise.resolve(api.get('/admin/order/filter'));
export const updateStatus = (data: IPostUpdateStatus) => Promise.resolve(api.post('/admin/order/update-status', data));
export const updateOrderStatus = (data: IPostUpdateOrderStatus) => Promise.resolve(api.post('/admin/order/update-order-status', data));
export const updateOrderAddress = (data: IUpdateAddressRequest) => Promise.resolve(api.post('/admin/order/update-address', data));